export default window.Overleaf;
